import { render, staticRenderFns } from "./CollaboratorsView.vue?vue&type=template&id=12f36c77&"
import script from "./CollaboratorsView.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports